import { RadialBarChart } from "components/Common"
import { withTranslation } from "react-i18next"
import {
  getSampleResult,
} from "helpers/fakebackend_helper"
import { Fragment, useEffect, useState } from "react"
import { Card, CardBody, CardHeader, Col, Row } from "reactstrap"

const BodyRight = ({ data, t }) => {
  const [stateSample, setStateSample] = useState({})

  useEffect(() => {
    setStateSample(data.stateSample)
  }, [data])

  // useEffect(() => {
  //   onFetchSampleResult()
  // }, [])

  // const onFetchSampleResult = async () => {
  //   await getSampleResult().then(res => setSampleResult(res))
  // }

  return (
    <Fragment>
      <Row className="h-100">
        <Col lg="12" key={1} className="mb-3">
          <Card className="h-100" style={{ minHeight: "120px" }}>
            <CardHeader
              style={{
                textAlign: "center",
                background: "#fff",
                paddingBottom: "8px",
                paddingTop: "12px",
              }}
            >
              <div style={{ fontSize: 16, fontWeight: 600 }}>
                {t('SampleWaiting')}
              </div>
            </CardHeader>
            <CardBody
              style={{
                textAlign: "center",
                paddingTop: "8px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                flex: 1
              }}
            >
              <div style={{ fontSize: 36, fontWeight: "bold", color: "#495057" }}>
                {stateSample?.sampleWaiting || 0}
              </div>
            </CardBody>
          </Card>
        </Col>
        <Col lg="6" key={2} className="mb-3">
          <Card className="h-100" style={{ minHeight: "120px" }}>
            <CardHeader
              style={{
                textAlign: "center",
                background: "#fff",
                paddingBottom: "8px",
                paddingTop: "12px",
              }}
            >
              <div style={{ fontSize: 16, fontWeight: 600 }}>
                {t('SampleValid')}
              </div>
            </CardHeader>
            <CardBody
              style={{
                textAlign: "center",
                paddingTop: "8px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                flex: 1
              }}
            >
              <div style={{ fontSize: 36, fontWeight: "bold", color: "#495057" }}>
                {stateSample?.sampleValid || 0}
              </div>
            </CardBody>
          </Card>
        </Col>
        <Col lg="6" key={3} className="mb-3">
          <Card className="h-100" style={{ minHeight: "120px" }}>
            <CardHeader
              style={{
                textAlign: "center",
                background: "#fff",
                paddingBottom: "8px",
                paddingTop: "12px",
              }}
            >
              <div style={{ fontSize: 16, fontWeight: 600 }}>
                {t('SampleAnalysis')}
              </div>
            </CardHeader>
            <CardBody
              style={{
                textAlign: "center",
                paddingTop: "8px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                flex: 1
              }}
            >
              <div style={{ fontSize: 36, fontWeight: "bold", color: "#495057" }}>
                {stateSample?.sampleAnalysis || 0}
              </div>
            </CardBody>
          </Card>
        </Col>
        {/* <div className="d-flex">
          {tatGeneral.map((item, index) => (
            <Col lg="6" key={index}>
              <Card className="mb-2" style={{ minHeight: "20%" }}>
                <CardHeader
                  style={{
                    textAlign: "center",
                    background: "#fff",
                    paddingBottom: 0,
                  }}
                >
                  <div style={{ fontSize: 15, fontWeight: 600 }}>{item.title}</div>
                </CardHeader>
                <CardBody style={{ textAlign: "center", paddingTop: 0 }}>
                  <div style={{ fontSize: 24, fontWeight: "bold" }}>
                    {item.value} Min
                  </div>
                </CardBody>
              </Card>
            </Col>
          ))}
        </div> */}

        {/* <Col lg="12" style={{ height: 280 }}>
          <Card className="mb-2" style={{ height: "100%" }}>
            <CardHeader
              style={{
                textAlign: "center",
                background: "#fff",
                paddingBottom: 0,
              }}
            >
              <div style={{ fontSize: 15, fontWeight: 600 }}>Tổng số mẫu</div>
            </CardHeader>
            <CardBody style={{ paddingTop: 0 }}>
              <ul className="list-group list-group-flush">
                <li
                  className="list-group-item"
                  style={{ paddingTop: 0, paddingBottom: 0 }}
                >
                  <div className="py-2">
                    <h5 className="font-size-14">
                      Trong ngày{" "}
                      <span className="float-end">
                        {sampleDetailTotal?.Total}
                      </span>
                    </h5>
                  </div>
                </li>
                {sampleDetailTotal.Detail?.map((item, index) => (
                  <li
                    key={index}
                    className="list-group-item"
                    style={{ paddingTop: 0, paddingBottom: 0 }}
                  >
                    <div className="py-2">
                      <h5 className="font-size-14">
                        {item.title}
                        <span className="float-end">{item.value}%</span>
                      </h5>
                      <div className="progress animated-progess progress-sm">
                        <div
                          className="progress-bar"
                          role="progressbar"
                          style={{
                            width: `${item.value}%`,
                            background: `${item.color}`,
                          }}
                          aria-valuenow={`${item.value}%`}
                          aria-valuemin="0"
                          aria-valuemax="100"
                        ></div>
                      </div>
                    </div>
                  </li>
                ))}
              </ul>
            </CardBody>
          </Card>
        </Col> */}


      </Row>

    </Fragment>
  )
}

export default withTranslation('generalDashboard')(BodyRight)
